import {parsePhoneNumberFromString} from 'libphonenumber-js'

function IsPhone(phoneNumber) {
    const p = parsePhoneNumberFromString(phoneNumber,'CN')
    return p.isValid()
}
export  {IsPhone}